import {dateTime} from "services/date";
import {Voucher} from "../../../types/Voucher";

/**
 * Transform the given voucher by deserializing object properties
 *
 * @internal
 * @param voucher
 */
export default function deserializeVoucher(voucher: any): Voucher {
    voucher.issued_at = dateTime(voucher.issued_at)
    voucher.valid_at = dateTime(voucher.valid_at)
    voucher.expires_at = dateTime(voucher.expires_at)
    voucher.first_redeemed_at = dateTime(voucher.first_redeemed_at)
    voucher.last_redeemed_at = dateTime(voucher.last_redeemed_at)
    voucher.created_at = dateTime(voucher.created_at)
    voucher.created_at = dateTime(voucher.created_at)
    voucher.updated_at = dateTime(voucher.updated_at)

    return voucher;
}